module.exports = __webpack_public_path__ + "static/media/copy.a483c9e4.svg";